import { render } from "./ArchivalMeasurements.vue?vue&type=template&id=458f2b8a&scoped=true"
import script from "./ArchivalMeasurements.vue?vue&type=script&lang=js"
export * from "./ArchivalMeasurements.vue?vue&type=script&lang=js"

import "./ArchivalMeasurements.vue?vue&type=style&index=0&id=458f2b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458f2b8a"]])

export default __exports__